import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import routes_web from '../../connections/routes_web';

import NavbarTop from './moduleComponents/NavbarTop';
import NavbarMiddle from './moduleComponents/NavbarMiddle';
import ViewBackHeader, { useReturnToPrevious } from './moduleComponents/ViewBackHeader';
import TabSettings from './tab_settings/settings_main';
import ViewAccountAudit from './tab_settings/view_account_audit';

const GeneralSettingsMain = () => {
  const navigate = useNavigate();
  const goBack = useReturnToPrevious();
  const [activeTab, setActiveTab] = useState('edit');

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4">
      <div className="max-w-5xl w-full mx-auto pt-14">
        <NavbarTop
          title="Ecosystem"
          onHomeClick={() => navigate(routes_web.accounts_home)}
        />

        <div>
          <ViewBackHeader title="General settings" onBack={goBack} />
          <NavbarMiddle activeTab={activeTab} setActiveTab={setActiveTab} />
          {activeTab === 'audit' ? <ViewAccountAudit /> : <TabSettings />}
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingsMain;
